import { render, staticRenderFns } from "./ListGalleryByProduct.vue?vue&type=template&id=5515d47a"
import script from "./ListGalleryByProduct.vue?vue&type=script&lang=js"
export * from "./ListGalleryByProduct.vue?vue&type=script&lang=js"
import style0 from "./ListGalleryByProduct.vue?vue&type=style&index=0&id=5515d47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports